

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 19C2 21.2091 3.79086 23 6 23H22C24.2091 23 26 21.2091 26 19V9C26 6.79086 24.2091 5 22 5H6C3.79086 5 2 6.79086 2 9V19ZM20 14H22C22.5523 14 23 13.5523 23 13V12C23 11.4477 22.5523 11 22 11H20C19.4477 11 19 11.4477 19 12V13C19 13.5523 19.4477 14 20 14ZM23 19V17H5V19C5 19.5523 5.44772 20 6 20H22C22.5523 20 23 19.5523 23 19Z","fill":"currentColor"}, []), "\n"]);
};

        